module.exports = __webpack_public_path__ + "static/img/product06-2.55e79c7a.png";